<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <div class="d-flex flex-wrap" *ngIf="token">
    <div class="two-card common-padding add-money shadow">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
      &nbsp;
      <h2 class="heading">Add Mobile Money Beneficiary </h2>
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="row no-gutters">
            <div class="col-12 form-padding">
              <form class="example-form" (ngSubmit)="submitMobileMoneyBeneficiaryForm(mobileMoneyBeneficiaryForm.value)" [formGroup]="mobileMoneyBeneficiaryForm">
                <div class="row no-gutters">
                  <div class="col-md-12">
                    <div class="row no-gutters">
                      <div class="col-12">
                        <mat-form-field>
                          <mat-label>Select Beneficiary Type</mat-label>
                          <mat-select formControlName="beneficiary_type" required>
                            <mat-option [value]="d?.code" *ngFor="let d of BeneficiaryTypelist; let i=index">
                              {{d?.doc_Name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_type?.errors?.required">
                            Select Beneficiary Type is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!--<div class="col-12">
    <mat-form-field>
      <mat-label>Select Beneficiary Account Type</mat-label>
      <mat-select formControlName="beneficiary_service_Accountcode">
        <mat-option [value]="d?.code" *ngFor="let d of BeneficiaryRelationshiplist; let i=index">
          {{d?.doc_Name}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="submitted && f.beneficiary_service_Accountcode?.errors?.required">
        Select Beneficiary Account Type is required
      </mat-error>
    </mat-form-field>
  </div>-->

                      <div class="col-12">
                        <mat-form-field>
                          <mat-label>Select Country</mat-label>
                          <mat-select formControlName="beneficiary_country_Accountcode" required>
                            <mat-form-field>
                              <input matInput [formControl]="CountryFilterCtrl" placeholder="Search Country" />
                            </mat-form-field>
                            <mat-option [value]="d?.code" *ngFor="let d of filterCountry(); let i=index" (click)="GetCurrentchannelVal(d?.code,d?.countryISDCode)">
                              <img matSuffix [src]="d?.icon" style="height: 20px;width: 20px;" />
                              {{d?.name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_country_Accountcode?.errors?.required">
                            Select Country is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <mat-label>Select Channel</mat-label>
                          <mat-select formControlName="channel_Code" required>
                            <mat-option [value]="d?.code" *ngFor="let d of channelList?.payservices; let i=index">
                              <img matSuffix [src]="d?.icon" style="height: 30px;width: 30px;" />
                              {{d?.name}}
                            </mat-option>

                          </mat-select>
                          <mat-error *ngIf="submitted && f.channel_Code?.errors?.required">
                            Select Channel is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary First Name" formControlName="beneficiary_fname" maxlength="50" required />
                          <mat-error *ngIf="submitted && f.beneficiary_fname?.errors?.required">
                            Enter Beneficiary First Name
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_fname?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary Last Name" formControlName="beneficiary_lname" maxlength="50" required />

                          <mat-error *ngIf="submitted && f.beneficiary_lname?.errors?.required">
                            Enter Beneficiary Last Name
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_lname?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary Address" formControlName="beneficiary_address" maxlength="150" required />

                          <mat-error *ngIf="submitted && f.beneficiary_address?.errors?.required">
                            Enter Beneficiary Address
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_address?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>

                        </mat-form-field>
                      </div>
                      <div class="col-12">
                        <mat-form-field class="example-full-width input-tel">
                          <span matPrefix>{{countryISDCode}} &nbsp;</span>
                          <input type="tel" matInput placeholder="Beneficiary Mobile Money Number (eg:244476305)"
                                 formControlName="beneficiary_phone" Numberonly minlength="1" maxlength="20" required />
                          <mat-error *ngIf="submitted && f.beneficiary_phone?.errors?.required">
                            Beneficiary Mobile Money No. is required
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_phone?.errors?.maxlength">
                            Maximum Length Beneficiary Mobile Money No. is 20
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_phone?.errors?.minlength">
                            Minimum Length Beneficiary Mobile Money No. is 1
                          </mat-error>
                        </mat-form-field>
                      </div>


                      <div class="col-12">
                        <mat-form-field>
                          <input matInput type="email" placeholder="Beneficiary Email" formControlName="beneficiary_email" maxlength="100" required />
                          <mat-error *ngIf="submitted && f.beneficiary_email.errors">
                            Enter Valid Email
                          </mat-error>
                        </mat-form-field>

                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <mat-label>Select Beneficiary Relationship with Sender</mat-label>
                          <mat-select formControlName="beneficiary_relationship" required>
                            <mat-option [value]="d?.code" *ngFor="let d of BeneficiaryRelationshiplist; let i=index" (click)="CheckBeneficiaryRelationship(d?.code)">
                              {{d?.doc_Name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_relationship?.errors?.required">
                            Select Beneficiary Relationship with Sender is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12" *ngIf="OtherRemarkslist">
                        <mat-form-field>
                          <mat-label>Select Other Remarks</mat-label>
                          <mat-select formControlName="beneficiary_Other_Remarks" required>
                            <mat-option [value]="d?.code" *ngFor="let d of OtherRemarkslist; let i=index">

                              {{d?.doc_Name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_Other_Remarks?.errors?.required">
                            Select Other Remarks is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12" >
                        <mat-form-field class="example-full-width">
                          <mat-label> Sender Fund Source</mat-label>
                          <mat-select formControlName="senderSourceOfFund" required>
                            <mat-option [value]="d?.data" *ngFor="let d of senderSourceOfFundlist; let i=index">
                              {{d?.value}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.senderSourceOfFund?.errors?.required">
                            Select Sender Fund Source
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field class="example-full-width">
                          <mat-label> Remittance Purpose</mat-label>
                          <mat-select formControlName="purposeofremittance" required>
                            <mat-option [value]="d?.data" *ngFor="let d of purposeofremittancelist; let i=index">
                              {{d?.value}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.purposeofremittance?.errors?.required">
                            Select Remittance Purpose
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field class="example-full-width">
                          <mat-label> Beneficiary Id Type</mat-label>
                          <mat-select formControlName="beneficiary_id" required>
                            <mat-option [value]="d?.code" *ngFor="let d of Idprooflist; let i=index">
                              {{d?.doc_Name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_id?.errors?.required">
                            Select Beneficiary Id Type
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="Beneficiary Id Number" maxlength="100" formControlName="beneficiary_id_number" required>
                          <mat-error *ngIf="submitted && f.beneficiary_id_number?.errors?.required">
                            Enter Beneficiary Id Number
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <!--<div class="col-12">
    <mat-form-field class="example-full-width">

      <input matInput placeholder="Sender Date of birth"
             [matDatepicker]="picker1" [max]="maxDate" maxlength="10"
             formControlName="SenderDateofbirth" required>
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>

      <mat-datepicker #picker1></mat-datepicker>
      <mat-error *ngIf="submitted && f.SenderDateofbirth?.errors?.required">
        Select Sender Date of birth
      </mat-error>
    </mat-form-field>

  </div>

  <div class="col-12">
    <mat-form-field class="example-full-width">
      <input matInput placeholder="Sender Address"
             maxlength="100" formControlName="SenderAddress" required />

      <mat-error *ngIf="submitted && f.SenderAddress?.errors?.required">
        Enter Sender Address
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-12">
    <mat-form-field class="example-full-width">
      <input matInput placeholder="Sender City"
             maxlength="20" formControlName="SenderCity" required />

      <mat-error *ngIf="submitted && f.SenderCity?.errors?.required">
        Enter Sender City
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-12">
    <mat-form-field class="example-full-width">
      <input matInput placeholder="Receiver First Name"
             maxlength="100" formControlName="ReceiverFirstName" required />

      <mat-error *ngIf="submitted && f.ReceiverFirstName?.errors?.required">
        Enter Receiver First Name
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-12">
    <mat-form-field class="example-full-width">
      <input matInput placeholder="Receiver Last Name"
             maxlength="100" formControlName="ReceiverLastName" required />

      <mat-error *ngIf="submitted && f.ReceiverLastName?.errors?.required">
        Enter Receiver Last Name
      </mat-error>
    </mat-form-field>
  </div>-->


                    </div>
                  </div>


                  <div class="col-12">
                    <button class="primary-btn" type="submit"> SUBMIT</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12 mt-4">
          <div class="pay-detail text-center">
            <div class="icon_wrap">
              <i class="icon-payment_secure"></i>
            </div>
            <span class="ng-binding">Your payment details are secured</span>
          </div>
        </div>
      </div>
    </div>
    <div class="two-card recent-card common-padding pay-money shadow overflow-auto">
      <h2 class="heading recent-head">Beneficiary Add</h2>
      <table class="table table-hover text-center  table-bordered">
        <thead>
          <tr>
            <th>Country</th>
            <th>Category Name</th>
            <th>Channel</th>
            <th>Mobile No.</th>
          </tr>
        </thead>

        <tbody *ngFor="let x of userorderdetailList; let i=index">
          <tr>
            <td>
              {{x.beneficiary_country}}
            </td>

            <td>{{x.beneficiary_serviceName}}</td>
            <td>{{x.channel}}</td>
            <td>{{x.beneficiary_phone}}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

</fieldset>
